import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function C_info() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="Android" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                Android
              </h1>
              <p className="text-secondary" id="Language_Para">
                Android is a mobile operating system based on a modified version
                of the Linux kernel and other open-source software, designed
                primarily for touchscreen mobile devices such as smartphones and
                tablets.
                <br />
                The main purpose of Android OS is of course to support the
                mobile smartphones/smart-devices environment. Since it is
                open-source, it is very flexible for hardware manufacturer.
                <br />
                1) It is open-source.
                <br /> 2) Anyone can customize the Android Platform.
                <br /> 3) There are a lot of mobile applications that can be
                chosen by the consumer.
                <br /> 4) It provides many interesting features like weather
                details, opening screen, live RSS (Really Simple Syndication)
                feeds.
                <br />
                At the end of the day, there are a lot of reasons that make
                Android a better choice for both end users and app developers.
                The software is simple to use, free and allows a lot more
                flexibility. You have a lot more freedom as an app user and
                developer using Android.
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
